import Fade from '@material-ui/core/Fade'
import Timeline from 'Shared/components/Timeline/Timeline'
import Options from './Options/Options'
import ActivityCard from './ActivityCard/ActivityCard'
import { TARGET_ACTIVITY_DEFAULT_COUNT, TARGET_ACTIVITY_LOAD_MORE_INCREMENT } from './constants'
import './ActivityLog.scoped.scss'

const ActivityLog = ({ target }) => {
  const actions = useAct()
  const [loaded, setLoaded] = useState()
  const [channel, setChannel] = useState('All')
  const [countToLoad, setCountToLoad] = useState(TARGET_ACTIVITY_DEFAULT_COUNT)
  const [targetActivity, setTargetActivity] = useState([])

  useEffect(() => {
    if (target && !_.isEmpty(target) && !loaded) {
      actions.target.loadActivity(countToLoad)
      setLoaded(true)
    }
  }, [target])

  useEffect(() => {
    if (target && !_.isEmpty(target)) {
      actions.target.loadActivity(countToLoad).then(() => {
        setTargetActivity(target.activity)
      })
    }
  }, [countToLoad])

  const onLoadMore = () => {
    setCountToLoad(countToLoad + TARGET_ACTIVITY_LOAD_MORE_INCREMENT)
  }

  useEffect(() => {
    if (target?.activity) {
      if (channel && channel !== 'All') {
        setTargetActivity(
          target.activity.filter((activity) =>
            activity.topic.toLowerCase().includes(channel.toLowerCase())
          )
        )
      } else {
        setTargetActivity(target.activity)
      }
    }
  }, [target?.activity])

  const filterByChannel = (channel) => {
    setChannel(channel)
    if (channel === 'All') {
      setTargetActivity(target?.activity)
      return
    }
    setTargetActivity(
      target?.activity.filter((activity) =>
        activity.topic.toLowerCase().includes(channel.toLowerCase())
      )
    )
  }

  return (
    <Fade in={loaded}>
      <div className="root" item>
        <div>
          <Options
            channelSelection={(channel) => filterByChannel(channel)}
            channelToLoad={channel}
          />
        </div>
        <div className="timeline-container">
          {targetActivity.length === 0 && <p>There's no activity to show.</p>}
          <Timeline
            {...{
              items: targetActivity,
              height: 'auto',
              ItemComponent: ({ item }) => <ActivityCard activity={item} />,
              ItemComponentProps: {},
              options: {
                chunk: { highlight: false, reverse: true },
                fade: { height: 160, offset: 80 },
              },
            }}
          />
        </div>
        <div
          className="button secondary no-margin-left load-more"
          onClick={onLoadMore}
        >
          Load more
        </div>
      </div>
    </Fade>
  )
}

export default ActivityLog
